

  export default {
    layout: 'nothing',

    scrollToTop: true,
    head(){
        return {
            bodyAttrs: {
                class: this.dataLoaded ? '' : 'pb-0'
            }
      }
    },

  mounted() {
  },


    data() {
      return {
        title: 'Goa News App',
        dataLoaded: false
      }
    },
    head() {
      return {
        bodyAttrs: {
                class: this.dataLoaded ? '' : 'pb-0'
            },
        title: this.title + " | Goa News Today",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa News App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa News App"
          }
        ]
      }
    }
  

  }

